'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconExclamationMark, iconExclamationMarkTag } from '@ni/nimble-components/dist/esm/icons/exclamation-mark';
import { wrap } from '../../utilities/react-wrapper';

export type { IconExclamationMark };
export { iconExclamationMarkTag };
export const NimbleIconExclamationMark = wrap(IconExclamationMark);